__webpack_require__.p = "/table-header-icon-poc/referrals-hub/";